/**
 * Legal documents as data, rendered both as pages and inside the footer
 * modal. Strings accept the roadmap's inline markup (`<b>`, `<a href>`).
 */

export type LegalSection = {
  heading: string;
  /** Paragraphs shown above the optional bullet list / table. */
  paragraphs?: string[];
  bullets?: string[];
  table?: { head: string[]; rows: string[][] };
  /** Paragraphs shown after the bullet list / table. */
  notes?: string[];
};

export type LegalDocumentData = {
  title: string;
  lastUpdated: string;
  intro: string;
  sections: LegalSection[];
};

/**
 * Documents the footer opens in a modal. Each is loaded on demand, so their
 * text never weighs on pages where nobody opens them.
 */
export const LEGAL_DOCUMENTS = {
  privacy: { href: "/privacy-policy/", load: () => import("./privacy-policy") },
  terms: { href: "/termini/", load: () => import("./termini") },
} as const;

export type LegalDocumentId = keyof typeof LEGAL_DOCUMENTS;
